const IDOZONA = 'Europe/Budapest';

/** A `toLocaleString('hu-HU')` nem törhető szóközt ad; sima szóközre cseréljük. */
function szokoz(s: string): string {
  return s.replace(/[  ]/g, ' ');
}

export function formatFt(n: number): string {
  return `${szokoz(Math.round(n).toLocaleString('hu-HU'))} Ft`;
}

function millio(n: number): string {
  return szokoz((Math.round(n / 100_000) / 10).toLocaleString('hu-HU', { maximumFractionDigits: 1 }));
}

export function formatMillioSav(min: number, max: number): string {
  return `${millio(min)}–${millio(max)} millió Ft`;
}

function reszek(iso: string, opciok: Intl.DateTimeFormatOptions): Record<string, string> {
  const r: Record<string, string> = {};
  for (const p of new Intl.DateTimeFormat('hu-HU', { timeZone: IDOZONA, ...opciok }).formatToParts(new Date(iso))) {
    r[p.type] = p.value;
  }
  return r;
}

export function formatDatum(iso: string): string {
  const r = reszek(iso, { year: 'numeric', month: '2-digit', day: '2-digit' });
  return `${r.year}. ${r.month}. ${r.day}.`;
}

export function formatDatumIdo(iso: string): string {
  const r = reszek(iso, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  return `${r.year}. ${r.month}. ${r.day}. ${r.hour}:${r.minute}`;
}

export function formatIdo(iso: string): string {
  const r = reszek(iso, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  return `${r.hour}:${r.minute}`;
}

/** +36301234567 → +36 30 123 4567; ami nem magyar mobil E.164, változatlanul megy vissza. */
export function telefonMegjelenites(e164: string): string {
  const m = /^\+36(\d{2})(\d{3})(\d{4})$/.exec(e164);
  return m ? `+36 ${m[1]} ${m[2]} ${m[3]}` : e164;
}
